import { render } from "./UploadLimitManager.vue?vue&type=template&id=2fbb8330"
import script from "./UploadLimitManager.vue?vue&type=script&lang=js"
export * from "./UploadLimitManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__